export const LANG = {
  TC: "TC",
  EN: "EN",
  SC: "SC",
  TC_TB: "TC_TB",
  EN_TB: "EN_TB",
  SC_TB: "SC_TB",
  TC_TESTING_CENTRE: "TC_TESTING_CENTRE",
  EN_TESTING_CENTRE: "EN_TESTING_CENTRE",
  SC_TESTING_CENTRE: "SC_TESTING_CENTRE",
  TC_MTR_TAXI: "TC_MTR_TAXI",
  EN_MTR_TAXI: "EN_MTR_TAXI",
  SC_MTR_TAXI: "SC_MTR_TAXI",
  TC_COUNTER: "TC_COUNTER",
  EN_COUNTER: "EN_COUNTER",
  SC_COUNTER: "SC_COUNTER",
  TC_LEAVE_HOME_SAFE: "TC_LEAVE_HOME_SAFE",
  EN_LEAVE_HOME_SAFE: "EN_LEAVE_HOME_SAFE",
  SC_LEAVE_HOME_SAFE: "SC_LEAVE_HOME_SAFE"
}

export const MQTT_MSG_TYPE = {
  PICKUP_ADD: 'PICKUP_ADD',
  PICKUP_REMOVE: 'PICKUP_REMOVE',
  PICKUP_REMOVE_ALL: 'PICKUP_REMOVE_ALL',
  TOPIC_ALIVE: 'TOPIC_ALIVE',
  TAG_BATCH: 'TAG_BATCH',
  TICKET: 'TIC',
  TAG: 'TAG',
  SPEAK: 'SPEAK'
}
export const MQTT_RESET_TIME = 10000;

export const QUEUE_STEPS = {
  CURRENT_SECTION: 'CURRENT_SECTION',
  SIZE: 'SIZE',
  TIME_SECTION: 'TIME_SECTION',
  TICKET_TYPE: 'TICKET_TYPE',
  TABLE_TYPE: 'TABLE_TYPE',
  DATE: 'DATE',
  TAGS: 'TAGS',
  PERSONAL_DATA: 'PERSONAL_DATA',
  PREVIEW: 'PREVIEW'
}

export const PERSONAL_DATAS = {
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',
  COUNTRY_CODE: 'COUNTRY_CODE',
  TAC: 'TAC'
}

export const TICKET_DETAIL = {
  TABLE_SIZE: 'tableSize',
  TIME_SECTION: 'timeSectionLabel',
  TICKET_TYPE: 'ticketTypeLabel',
  TABLE_TYPE: 'tableTypeLabel',
  DATE: 'startTimestamp',
  TAGS: 'selectTagList',
  PERSONAL_DATA: 'PERSONAL_DATA',
}

export const DELIVERY_TYPE = {
  EMAIL: 'EMAIL',
  SMS: 'SMS'
}

export const STATUS = {
  ACTIVE: 'A'
}

export const NAVIGATION = {
  PRE_REGISTRATION: 'PRE_REGISTRATION',
  MOBILE_QUEUE: 'MOBILE_QUEUE'
}

export const ELEMENT = {
  PROMOTION_TNC: "PROMOTION_TNC",
  SITE_LIST_LOGO: "SITE_LIST_LOGO",
  SITE_DETAIL_QUEUE_TITLE: "SITE_DETAIL_QUEUE_TITLE",
  SITE_DETAIL_BANNER_LIST: "SITE_DETAIL_BANNER_LIST",
  SITE_DETAIL_NAVIGATION_LIST_TOP: "SITE_DETAIL_NAVIGATION_LIST_TOP",
  SITE_DETAIL_NAVIGATION_LIST_BOTTOM: "SITE_DETAIL_NAVIGATION_LIST_BOTTOM",
  SITE_DETAIL_BOTTOM_BUTTON: "SITE_DETAIL_BOTTOM_BUTTON",
  SITE_DETAIL_NAV_PRE_REG_ICON: "SITE_DETAIL_NAV_PRE_REG_ICON",
  SITE_DETAIL_NAV_QRCODE_ICON: "SITE_DETAIL_NAV_QRCODE_ICON",
  SITE_DETAIL_MOBILE_QUEUE: "SITE_DETAIL_MOBILE_QUEUE",
  SITE_DETAIL_TAG_SEQUENCE_LIST: "SITE_DETAIL_TAG_SEQUENCE_LIST",
  SITE_DETAIL_DATE:"SITE_DETAIL_DATE",
  SITE_DETAIL_COUNTER_TAG_LIST: "SITE_DETAIL_COUNTER_TAG_LIST",
  SITE_INFO_SITE_LOGO: "SITE_INFO_SITE_LOGO",
  TAG_SEQUENCE_CALL_LOGO: "TAG_SEQUENCE_CALL_LOGO",
  TICKET_DETAIL_TAG_SEQUENCE_LIST: "TICKET_DETAIL_TAG_SEQUENCE_LIST", 
  TICKET_DETAIL_COUNTER_TAG_LIST: "SITE_DETAIL_COUNTER_TAG_LIST",
  TICKET_DETAIL_BGCOLOR: "TICKET_DETAIL_BGCOLOR",
}

export const PATH_LOCATION = {
  SITE_DETAIL: "SITE_DETAIL",
  SITE_DETAIL_MAP: "SITE_DETAIL_MAP",
  TICKET: "TICKET",
}

export const COLOR = {
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  LEAVE_HOME_SAFE_YELLOW: "#F9DB56",
}